var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.045 8l6.001-6.001L17.048 8h-.002v10h-12V8h-.001zM3.046 9.999L1.57 11.475.156 10.063 9.633.585c.78-.78 2.046-.78 2.826 0l9.477 9.477-1.413 1.414-1.477-1.477V18a2 2 0 01-2 2h-12a2 2 0 01-2-2V9.999z",
    fill: "#7C8193"
  })));
}
export default __webpack_public_path__ + "media/images/homeIcon-88ab2432.svg";
export { SvgHomeIcon as ReactComponent };